import { useCtaConfigTypes } from "./useCtaConfigTypes";
import { useBnbSelector } from "../../../redux/store";
import type { CtaButtonType } from "../../../../../../common-deprecated/server/data/FormatBnbCtas";
import { isRetailerApps } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import {
    canNavigateToBuyStep,
    canNavigateToLeaseStep,
    canNavigateToReserveStep,
} from "../../../../../shared-logic/utils/checkoutUtils";
import type { FinanceRateStateType } from "../../../redux/reducers/FinanceRateReducer";

// Returns the correct list of ctas and filters out disabled / hidden ctas
const useCtaList = (
    type: "mainCtas" | "customizeHeroCta" | "summaryBasketCta" | "notAvailableOnline",
): CtaButtonType[] => {
    const ctaConfigType = useCtaConfigTypes();
    const aemCtaConfigs = useBnbSelector((state) => state.bnbSettings.ctaConfigs);
    const allCtas = aemCtaConfigs?.[ctaConfigType]?.[type] || [];
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    const enableBuyStep = useBnbSelector((state) =>
        canNavigateToBuyStep<FinanceRateStateType>(
            state.bnbSettings.enableBuy,
            state.bnbSettings.allowedCheckoutFinanceProduct,
            state.finance,
            state.utils.financeOption,
            state.basket,
        ),
    );
    const enableReserveStep = useBnbSelector((state) =>
        canNavigateToReserveStep<FinanceRateStateType>(
            state.bnbSettings.enableReserve,
            state.bnbSettings.allowedCheckoutReserveProduct,
            state.finance,
            state.utils.financeOption,
        ),
    );
    const enableLeaseStep = useBnbSelector((state) =>
        canNavigateToLeaseStep<FinanceRateStateType>(
            state.bnbSettings.enableLeasing,
            state.bnbSettings.allowedCheckoutLeasingProduct,
            state.finance,
            state.utils.financeOption,
        ),
    );

    if (isRetailerApps(commonSettings)) return [];
    return (
        allCtas
            // Remove go to buy button when step is not enabled
            .filter((button) => button.type !== "go-to-buy" || enableBuyStep)
            // Remove go to reserve button when step is not enabled
            .filter((button) => button.type !== "go-to-reserve" || enableReserveStep)
            // Remove go to lease button when step is not enabled
            .filter((button) => button.type !== "go-to-lease" || enableLeaseStep)
    );
};

export default useCtaList;
